import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { CSSProperties } from 'react';
import { css } from 'styled-components';

export interface OpacityProps {
    op: CSSProperties['opacity'];
    opacity: CSSProperties['opacity'];
}

export const opacity = (defaultValue?: OpacityProps['opacity']): any => css`
    & {
        opacity: ${prop(['op', 'opacity'], defaultValue)};
    }
`;

opacity.clean = (props): any => cleanProps(props, ['op', 'opacity']);
